const state = {
  merchants: [],
};

const getters = {
  merchants: state => state.merchants
};

const actions = {
  setMerchants: ({ commit }, data) => { commit("setMerchants", data); },
  updateMerchant: ({ commit }, data) => { commit("updateMerchant", data); },
  addMerchant: ({ commit }, data) => { commit("addMerchant", data); },
  removeMerchant: ({ commit }, data) => { commit("removeMerchant", data); }
};

const mutations = {
  setMerchants(state, data) { state.merchants = data; },
  updateMerchant(state, data) {
    state.merchants = state.merchants.map(o => {
      if (o._id === data._id) return data;
      return o;
    });
  },
  addMerchant(state, data) { state.merchants.push(data); },
  removeMerchant(state, data) {
    state.merchants = state.merchants.filter(o => o._id !== data._id);
  }
};

export default { state, getters, actions, mutations };